import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { BaseLayout } from '../../../components/layout';
import { EnterpriseBuilderProFormWrapper } from './EnterpriseBuilderProForm/EnterpriseBuilderProFormWrapper';

export const EnterpriseBuilderProFormView = () => (
    <BaseLayout title={<LocalizedText textKey={TextKey.EnterpriseBuilderPro} />}>
        <EnterpriseBuilderProFormWrapper />
    </BaseLayout>
);
